import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from '../views/home/index.vue'
import LoginView from '../views/login/index.vue'
import RegisterView from '../views/register/index.vue'
import CSKH from '../views/cskh/index.vue'

import LoanPage from '../views/loanpage/index.vue'
import WalletView from '../views/wallet/index.vue'
import AccountView from '../views/account/index.vue'
import ContractView from '../views/account/contract.vue'
import ChangePwd from '../views/account/changepwd.vue'
import ProfileView from '../views/account/profile.vue'
import AutographView from '../views/account/autograph.vue'
import BankView from '../views/account/bank.vue'
import UsrInfo from '../views/account/usrinfo.vue'
import UsrCard from '../views/account/usrcard.vue'
import MyLoan from '../views/loan/index.vue'
import LoanInfo from '../views/loan/info.vue'
import BillView from '../views/account/bill.vue'
import ChangePayPwd from '../views/account/changepaypwd.vue'
import WithdrawRecord from '../views/wallet/record.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/home',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView
  },
  {
    path: '/cskh',
    name: 'cskh',
    component: CSKH
  },
  {
    path: '/loanpage',
    name: 'loanpage',
    component: LoanPage
  },
  {
    path: '/wallet',
    name: 'wallet',
    component: WalletView
  },
  {
    path: '/account',
    name: 'account',
    component: AccountView
  },
  {
    path: '/contract',
    name: 'contract',
    component: ContractView
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: ChangePwd
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/autograph',
    name: 'autograph',
    component: AutographView
  },
  {
    path: '/bank',
    name: 'bank',
    component: BankView
  },
  {
    path: '/usr',
    name: 'usr',
    component: UsrInfo
  },
  {
    path: '/card',
    name: 'card',
    component: UsrCard
  },
  {
    path: '/loan',
    name: 'loan',
    component: MyLoan
  },
  {
    path: '/loaninfo',
    name: 'loaninfo',
    component: LoanInfo
  },
  {
    path: '/changepaypwd',
    name: 'changepaypwd',
    component: ChangePayPwd
  },
  {
    path: '/withdrawrecord',
    name: 'withdrawrecord',
    component: WithdrawRecord
  },
  {
    path: '/bill',
    name: 'bill',
    component: BillView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
